import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getWalletByWaba,
  liveChatUpdateContacts,
  sendLiveChatMessage,
} from "../../store/actions/tenantAction";
import EmojiPicker from "emoji-picker-react";
import PopUp from "../../components/PopUp";
import FileUploader from "../../components/FileUploader";
import LocationPickerMap from "../../components/LocationPickerMap";
import { getAddress } from "../../utils/helper";
import AudioRecorder from "../../components/AudioRecorder";
import { mediaUploader, uploadFile } from "../../store/actions/globalAction";
import { SHOW_SNACKBAR } from "../../utils/types";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from 'uuid';

function SendWhatsAppMessageView({ selectedContact, setSelectedContact, canSendMsg, setSendMessageTemplate, accountType, isMobileView = false, updateTicket }) {
  let dispatch = useDispatch();
  const { t } = useTranslation();
  const [isSendEnable, setIsSendEnable] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [showSelectLocation, setShowSelectLocation] = useState(false);
  const [showAudioRecord, setShowAudioRecord] = useState(false);
  const [audioData, setAudioData] = useState({});
  const [mapLocation, setMapLocation] = useState({
    latitude: 21.4292064,
    longitude: 50.852764,
  });
  const [uploadFileData, setUploadFileData] = useState();
  const [type, setType] = useState();
  const [contactNotes, setContactNotes] = useState({});
  const [typedMessage, setTypedMessage] = useState("");
  const [bodyTextCurrentIndex, setBodyTextCurrentIndex] = useState("");
  const dropdownEmojiRef = useRef(null);
  const globalReducer = useSelector((state) => state.globalReducer);
  const [wallet, setWallet] = useState({ isWalletAvailable: false });

  useEffect(() => {
    if (globalReducer.waba?.id) {
      dispatch(
        getWalletByWaba({ tenantWabaId: globalReducer.waba?.id }, globalReducer.loginInfo?.tenantId, (w) => {
          if (globalReducer.waba?.accountType === "POSTPAID") {
            w.isWalletAvailable = (parseFloat(w?.availableWallet ?? 0) + parseFloat(globalReducer.waba?.walletLimit ?? 0)) > 0
          } else {
            w.isWalletAvailable = parseFloat(w?.availableWallet ?? 0) > 0
          }
          setWallet(w);
        })
      );
    }
  }, [globalReducer.waba?.id]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownEmojiRef.current &&
        !dropdownEmojiRef.current.contains(event.target)
      ) {
        setShowEmojiPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => { setTypedMessage(""); }, [selectedContact?.contact?.id]);

  const onSendMessage = () => {
    if (typedMessage) {
      setIsSending(true);
      setIsSendEnable(false);
      dispatch(
        sendLiveChatMessage(
          {
            tenantId: globalReducer.loginInfo?.tenantId,
            contact: selectedContact?.contact,
            contactId: selectedContact?.contact?.id,
            tenantWabaId: globalReducer.waba?.id,
            messageType: "LIVE_CHAT",
            type: "text",
            source: accountType,
            message: { text: { body: typedMessage } },
          },
          (a) => {
            setTypedMessage("");
            setIsSending(false);
          },
          false
        )
      );
      setTypedMessage("");
    }
  };

  const onFileSend = async (media) => {
    let messageData = { id: uploadFileData?.id, link: media?.url ? process.env.REACT_APP_PRODUCT_APIURL + "/storage/media/file?kay=" + media?.url : null };
    if (type === "location") {
      messageData = mapLocation;
    } else if (type === "audio") {
      messageData = { id: media?.id, link: media?.url ? process.env.REACT_APP_PRODUCT_APIURL + "/storage/media/file?kay=" + media?.url : null };
    } else if (type === "document") {
      messageData = { id: uploadFileData?.id, caption: uploadFileData?.filename, filename: uploadFileData?.filename, link: media?.url ? process.env.REACT_APP_PRODUCT_APIURL + "/storage/media/file?kay=" + media?.url : null };
    }
    if (accountType === "WEBLIVECHAT" && !media?.url) {
      messageData = { ...messageData, link: process.env.REACT_APP_PRODUCT_APIURL + "/storage/media/file?kay=" + uploadFileData?.url }
    }
    dispatch(
      sendLiveChatMessage(
        {
          tenantId: globalReducer.loginInfo?.tenantId,
          contact: selectedContact?.contact,
          contactId: selectedContact?.contact?.id,
          tenantWabaId: globalReducer.waba?.id,
          messageType: "LIVE_CHAT",
          type: type,
          source: accountType,
          message: { [type]: messageData },
        },
        (a) => {
          setShowFileUpload(false);
          setShowSelectLocation(false);
          setShowAudioRecord(false);
        }
      )
    );
  };

  const sendAudioMessage = () => {
    const formData = new FormData();
    const audioFile = new File(
      [audioData.audioBlob],
      `recording${new Date().getTime()}.mp3`,
      { type: "audio/mp3" }
    );
    formData.append("file", audioFile);
    setIsSendEnable(false);
    if (accountType === "WEBLIVECHAT") {
      const newUuid = uuidv4();
      const key = `weblivechat/${globalReducer.loginInfo?.tenantId}/${globalReducer.waba?.id}/${newUuid}.${audioFile.name.split('.').pop()}`;
      dispatch(uploadFile(formData, key, a => {
        if (a) {
          onFileSend({
            url: key,
            mediaType: audioFile.type,
            filename: audioFile.name,
            type: type
          });
        }
      }));
      return;
    }
    dispatch(
      mediaUploader(
        formData,
        globalReducer.loginInfo?.tenantId,
        globalReducer.waba?.id,
        (a) => {
          if (a) {
            onFileSend({ ...a, url: null });
          }
        }
      )
    );
  };

  const insertText = (index, text, newText) => {
    return `${text.slice(0, index)}${newText}${text.slice(index)}`;
  };

  const onSaveNotes = () => {
    const data = {
      ids: [selectedContact?.id],
      detail: selectedContact?.detail,
    };
    dispatch(
      liveChatUpdateContacts(data, (a) => {
        dispatch({
          type: SHOW_SNACKBAR,
          payload: { type: "success", message: `saved`, open: true },
        });
      })
    );
  };

  const assignToMe = () => {
    const data = {
      ids: [selectedContact?.id],
      assigned_users: [globalReducer.loginInfo?.uid],
      assigned_group: {}
    };
    updateTicket(data);
  };

  const handleLocationChange = ({ latitude, longitude, address, name }) => {
    setMapLocation({ latitude, longitude, address, name });
    setIsSendEnable(true);
  };
  const isShowAssignToMe = (!globalReducer.loginInfo?.roleDetails?.some((s) => ["tenant_super_admin"].includes(s.name?.toLowerCase())) &&
    selectedContact?.detail?.assigned_group?.groupName);

  return (
    <div className="w-full flex flex-col bg-[#FFFFFF] border-[0.8px] border-[#E5E7EB] overflow-hidden rounded-[8px]">
      <div className="absolute z-99 top-5" ref={dropdownEmojiRef}>
        <EmojiPicker
          open={showEmojiPicker}
          autoFocusSearch
          onEmojiClick={(em) => {
            setTypedMessage(
              insertText(
                bodyTextCurrentIndex ?? 0,
                typedMessage ?? "",
                em.emoji
              )
            );
            setBodyTextCurrentIndex(
              (bodyTextCurrentIndex ?? 0) + em.emoji?.length
            );
            setIsSendEnable(true);
          }}
        />
      </div>
      <div className="flex-shrink-0 border-b-[0.8px] bg-[#F9FAFB] border-[#E5E7EB] px-3 sm:px-5 flex gap-3 items-end h-10">
        <div
          onClick={() => setContactNotes({ ...contactNotes, show: false })}
          className={`${contactNotes?.show ? "text-gray-500" : "text-theme border-theme"
            } font-semibold border-b-[2px] px-0.5 py-1 cursor-pointer text-sm sm:text-base`}
        >
          {t("Chat")}
        </div>
        <div
          onClick={() => setContactNotes({ ...contactNotes, show: true })}
          className={`${contactNotes?.show ? "text-theme border-theme" : "text-gray-500"
            } font-semibold border-b-[2px] px-0.5 py-1 cursor-pointer text-sm sm:text-base`}
        >
          {t("Notes")}
        </div>
      </div>
      {contactNotes?.show ? (
        <>
          <div className="flex-1 min-h-[70px] px-3 sm:px-5 py-2 bg-white">
            <textarea
              value={selectedContact?.detail?.notes ?? ""}
              onChange={(e) => {
                setSelectedContact({
                  ...selectedContact,
                  detail: { ...selectedContact?.detail, notes: e.target.value },
                });
              }}
              className="text-[#6B7280] w-full h-full border-none outline-none resize-none skipthis text-sm sm:text-base"
              placeholder="Type to save notes."
            ></textarea>
          </div>
          <div className="flex-shrink-0 px-3 sm:px-5 pb-2 pt-1 flex items-center justify-end">
            <button
              type="button"
              className={`bg-theme text-[#FFFFFF] rounded-[6px] px-3 py-1.5 text-sm sm:text-base`}
              onClick={onSaveNotes}
            >
              {t("Save")}
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="flex-1 min-h-0 flex flex-col">
            <div
              disabled={(!(canSendMsg && selectedContact?.ticketStatus === "OPEN") || isShowAssignToMe || (accountType !== "WEBLIVECHAT" && !wallet?.isWalletAvailable))}
              className="flex-1 min-h-[70px] px-3 sm:px-5 py-2 bg-white"
            >
              <textarea
                value={typedMessage}
                onChange={(e) => {
                  setTypedMessage(e.target.value);
                  setIsSendEnable(e.target.value ? true : false);
                }}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' && !event.shiftKey) {
                    event.preventDefault();
                    onSendMessage();
                  }
                }}
                className="text-[#6B7280] w-full h-full border-none outline-none resize-none skipthis text-sm sm:text-base"
                placeholder={t("Type to send a new message.")}
                onClick={(e) => setBodyTextCurrentIndex(e.target.selectionStart)}
                onKeyUp={(e) => setBodyTextCurrentIndex(e.target.selectionStart)}
              ></textarea>
            </div>
            {isShowAssignToMe ?
              <div className="relative flex items-center w-full justify-center z-50">
                <div className="absolute rounded-lg mt-[-22px] bg-[#FFFFFF]">
                  <div className="flex justify-center pb-5">
                    <button onClick={() => assignToMe()} className="bg-theme text-white px-4 py-2 rounded text-sm sm:text-base">
                      {t("Assign to me")}
                    </button>
                  </div>
                </div>
              </div>
              :
              (!canSendMsg || selectedContact?.ticketStatus !== "OPEN") && <div className="relative flex items-center w-full justify-center z-50">
                <div className="absolute rounded-lg mt-[-22px] bg-[#FFFFFF]">
                  <div className="flex justify-center pb-5">
                    <button onClick={() => setSendMessageTemplate(true)} className="bg-theme text-white px-4 py-2 rounded text-sm sm:text-base">
                      {t("Send a message template")}
                    </button>
                  </div>
                  <p className="text-[11px] sm:text-[12px]">{selectedContact?.ticketStatus !== "OPEN" ? "" : t("The 24 hr session is finished.")} {t("Please send a message template to restart the conversation.")}</p>
                </div>
              </div>}
            {accountType !== "WEBLIVECHAT" && !wallet?.isWalletAvailable && (
              <div className="relative flex items-center w-full justify-center z-50">
                <div className="absolute rounded-lg mt-[-22px] bg-[#FFFFFF]">
                  <p className="text-[11px] sm:text-[12px]">{t("Your wallet balance has been exhausted. Please recharge your wallet to continue.")}</p>
                </div>
              </div>
            )}
          </div>
          <div
            disabled={(!(canSendMsg && selectedContact?.ticketStatus === "OPEN") || isShowAssignToMe || (accountType !== "WEBLIVECHAT" && !wallet?.isWalletAvailable))}
            className="flex-shrink-0 px-3 sm:px-5 pb-2 pt-1 flex items-center justify-between border-t-[0.8px] border-[#E5E7EB]"
          >
            <div className="flex gap-3 sm:gap-5 items-center">
              <div onClick={() => setShowEmojiPicker(!showEmojiPicker)}>
                <i className="fa-solid fa-face-smile text-[#9CA3AF] cursor-pointer hover:text-theme transition-all text-base sm:text-lg"></i>
              </div>
              <div
                onClick={() => {
                  setUploadFileData(null);
                  setIsSendEnable(false);
                  setShowFileUpload(true);
                  setType("image");
                }}
              >
                <i className="fa-solid fa-image text-[#9CA3AF] cursor-pointer hover:text-theme transition-all text-base sm:text-lg"></i>
              </div>
              <div
                onClick={() => {
                  setUploadFileData(null);
                  setIsSendEnable(false);
                  setShowFileUpload(true);
                  setType("video");
                }}
              >
                <i className="fa-solid fa-video text-[#9CA3AF] cursor-pointer hover:text-theme transition-all text-base sm:text-lg"></i>
              </div>
              <div
                onClick={() => {
                  setUploadFileData(null);
                  setIsSendEnable(false);
                  setShowFileUpload(true);
                  setType("document");
                }}
              >
                <i className="fa-solid fa-file text-[#9CA3AF] cursor-pointer hover:text-theme transition-all text-base sm:text-lg"></i>
              </div>
              <div
                onClick={() => {
                  setIsSendEnable(false);
                  setShowAudioRecord(true);
                  setType("audio");
                }}
              >
                <i className="fa-solid fa-microphone text-[#9CA3AF] cursor-pointer hover:text-theme transition-all text-base sm:text-lg"></i>
              </div>
              {accountType !== "WEBLIVECHAT" && <>
                <div
                  onClick={() => {
                    setIsSendEnable(false);
                    setShowSelectLocation(true);
                    setType("location");
                  }}
                >
                  <i className="fa-solid fa-location-dot text-[#9CA3AF] cursor-pointer hover:text-theme transition-all text-base sm:text-lg"></i>
                </div>
                <div className="cursor-pointer text-[#9CA3AF] hover:text-theme transition-all" onClick={() => setSendMessageTemplate(true)}>
                  <svg fill="currentColor" width="24px" height="24px" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <path d="M28.5,68.5v-34H26.9a4.89,4.89,0,0,0-4.8,4.9V74.8a4.89,4.89,0,0,0,4.8,4.9H62.5a4.89,4.89,0,0,0,4.8-4.9V73.4h-34A4.89,4.89,0,0,1,28.5,68.5Z" /><path d="M46.4,30.2H64.1a1.58,1.58,0,0,0,1.6-1.6V25.3a4.89,4.89,0,0,0-4.8-4.9H49.6a4.82,4.82,0,0,0-4.8,4.9v3.3A1.64,1.64,0,0,0,46.4,30.2Z" />
                    <path d="M73,24.4H71.4a.74.74,0,0,0-.8.8v3.3a6.57,6.57,0,0,1-6.5,6.6H46.4a6.64,6.64,0,0,1-6.5-6.6V25.2a.74.74,0,0,0-.8-.8H37.5a4.82,4.82,0,0,0-4.8,4.9V64.6a4.89,4.89,0,0,0,4.8,4.9H73a4.82,4.82,0,0,0,4.8-4.9V29.4A4.85,4.85,0,0,0,73,24.4ZM60.9,55.5a1.58,1.58,0,0,1-1.6,1.6H43.1a1.58,1.58,0,0,1-1.6-1.6V53.9a1.58,1.58,0,0,1,1.6-1.6H59.3a1.58,1.58,0,0,1,1.6,1.6ZM69,47.3a1.58,1.58,0,0,1-1.6,1.6H43.1a1.58,1.58,0,0,1-1.6-1.6V45.7a1.58,1.58,0,0,1,1.6-1.6H67.4A1.58,1.58,0,0,1,69,45.7Z" />
                  </svg>
                </div>
              </>}
            </div>
            <div>
              <button
                type="button"
                disabled={!isSendEnable}
                className={`${isSendEnable
                  ? "bg-theme text-[#FFFFFF]"
                  : "bg-[#E5E7EB] text-[#9CA3AF]"
                  } rounded-[6px] px-3 py-1.5 text-sm sm:text-base`}
                onClick={onSendMessage}
              >
                {t("Send")}
              </button>
            </div>
          </div>
        </>
      )}
      <PopUp
        ModalHeader={
          <span className="font-medium text-[18px] text-black">
            {t("Upload File")}
          </span>
        }
        isShowModal={showFileUpload}
        setIsShowModal={setShowFileUpload}
        ModalBody={
          <div className="px-6 pb-6 pt-3 bg-white max-h-[550px] overflow-auto">
            <FileUploader
              wabaId={globalReducer?.waba?.id}
              tenantId={globalReducer?.waba?.tenantId}
              isSessionUploder={false}
              type={type}
              name={uploadFileData?.filename}
              selectedFileUrl={uploadFileData?.thumbnailUrl}
              filePrefix={accountType === "WEBLIVECHAT" ? `weblivechat/${globalReducer.loginInfo?.tenantId}/${globalReducer.waba?.id}` : "template_media"}
              isOwnUploder={accountType === "WEBLIVECHAT"}
              onUploaded={(file) => {
                if (type === "document") {
                  setUploadFileData({ ...file, caption: file.filename, filename: file.filename, header_handle: [file?.h] });
                } else {
                  setUploadFileData({ ...file, filename: null, header_handle: [file?.h] });
                }
                setIsSendEnable(true);
              }}
            />
            <div className="flex items-center justify-end mt-3">
              <button
                type="button"
                disabled={!isSendEnable}
                className={`${isSendEnable
                  ? "bg-theme text-[#FFFFFF]"
                  : "bg-[#E5E7EB] text-[#9CA3AF]"
                  } rounded-[6px] px-[12px] py-[4px]`}
                onClick={onFileSend}
              >
                {t("Send")}
              </button>
            </div>
          </div>
        }
        size="xl"
      />
      <PopUp
        ModalHeader={
          <span className="font-medium text-[18px] text-black">
            {t("Select Location")}
          </span>
        }
        isShowModal={showSelectLocation}
        setIsShowModal={setShowSelectLocation}
        ModalBody={
          <div className="px-4 pb-4 pt-2 bg-white">
            <LocationPickerMap
              value={mapLocation}
              onChange={handleLocationChange}
            />
            <div className="mt-3 flex items-center justify-end">
              <button
                type="button"
                disabled={!isSendEnable}
                className={`flex items-center gap-2 rounded-[6px] px-4 py-2 text-sm font-medium transition-colors min-w-[90px] justify-center ${isSendEnable
                  ? "bg-theme text-white hover:opacity-90"
                  : "bg-[#E5E7EB] text-[#9CA3AF] cursor-not-allowed"
                  }`}
                onClick={onFileSend}
              >
                <i className="fa-solid fa-paper-plane text-xs" />
                {t("Send")}
              </button>
            </div>
          </div>
        }
        size="xl"
      />
      <PopUp
        ModalHeader={
          <span className="font-medium text-[18px] text-black">
            {t("Audio Recorder")}
          </span>
        }
        isShowModal={showAudioRecord}
        setIsShowModal={setShowAudioRecord}
        ModalBody={
          <div className="px-4 pb-4">
            <AudioRecorder
              onStop={(data) => {
                setAudioData(data);
                setIsSendEnable(true);
              }}
            />
            <div className="flex items-center justify-end">
              <button
                type="button"
                disabled={!isSendEnable}
                className={`${isSendEnable
                  ? "bg-theme text-[#FFFFFF]"
                  : "bg-[#E5E7EB] text-[#9CA3AF]"
                  } rounded-[6px] px-[12px] py-[4px]`}
                onClick={sendAudioMessage}
              >
                {isSending ? "Sending..." : "Send"}
              </button>
            </div>
          </div>
        }
        size="xl"
      />
    </div>
  );
}

export default SendWhatsAppMessageView;
